<template>
        <v-chip
            class="ma-2"
            color="primary"
            outlined
            @click.prevent="download"
            :disabled="disableDownload"
        >
            <span v-if="downloadLoader">
             <span>{{$t('Downloading')}}</span><span><v-btn :disabled="true" depressed text class="downloadChip" :loading="downloadLoader"></v-btn></span>
            </span>
            <span v-else>{{doc.name}}</span>
        </v-chip>
</template>
<script>
export default {
    name: "FileDownload",
    props: ['doc'],
    data() {
        return { 
            downloadLoader:false,
            disableDownload:false
            }
    },
    methods: {
        download() {
             {
                this.downloadLoader = true
                this.disableDownload=true
                this.$services.document.download(this.doc).then((data) => {
                     this.downloadLoader = false
                     this.disableDownload=false
                    // this.modelWrapper[this.modelKey] = null;
                    // this.$emit('fileChange', {});
                }).catch(e=>{
                     this.downloadLoader = false
                     this.disableDownload=false
                })
            }
        },
}
}
</script>